import startCase from "lodash/startCase";
import { CLUSTER_HEALTH_ALERT_TARGET } from "./target";
const fallbackReadableTarget = (target) => target.split(".").map(startCase).join(" / ");
const readableHealthAlertTarget = (target, paths) => {
  if (target === CLUSTER_HEALTH_ALERT_TARGET) return "Cluster Health";
  const path = paths[target];
  return path ? path.map((segment) => segment.title).join(" / ") : fallbackReadableTarget(target);
};
export default readableHealthAlertTarget;
